<template>
  <div :class="fieldStyling">
    <div class="field__label flex items-center justify-between">
      <FieldLabel :field="field" />
      <ErrorMessage
        v-if="errors"
        :error="errorMessage"
      />
    </div>
    <FlatPickr
      v-model="value"
      :config="datepickerConfig"
      :class="{ 'error': errors.length }"
      :disabled="isDisabled"
    />
    <HelpText
      v-if="field.attributes.help"
      :help-text="field.attributes.help"
    />
  </div>
</template>

<script type="text/babel">
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index'

import HelpText from './HelpText'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import inputField from 'FormBuilder/Resources/assets/js/mixins/input-field.js'

export default {
  name: 'MonthField',
  components: {
    ErrorMessage,
    FlatPickr,
    FieldLabel,
    HelpText,
  },
  mixins: [inputField],
  data() {
    return {
      datepickerConfig: {
        plugins: [
          new monthSelectPlugin(),
        ],
      },
    }
  },
}
</script>
